"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MedicationList = require("./MedicationList");
Object.keys(_MedicationList).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MedicationList[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MedicationList[key];
    }
  });
});